import { render, staticRenderFns } from "./TicketReservations.vue?vue&type=template&id=3c4a34cc&scoped=true"
import script from "./TicketReservations.vue?vue&type=script&lang=js"
export * from "./TicketReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a34cc",
  null
  
)

export default component.exports